import { useContext, useMemo } from 'react';
import { Card, CarouselProps, Col, Container, Row } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import { useNavigate } from 'react-router-dom';
import useMobile from '../../hooks/useMobileHook';
import { ModalManagementStore } from '../../providers/modal-manager';
import { chunk } from '../../utils/utils';
import { MobileCarousel } from '../MobileCarousel/MobileCarousel';

export type CarouselCardInfo = {
  img?: string;
  title: string;
  id: string;
  subtitle?: string;
  link?: string;
  modal?: boolean;
};

export type customCarouselProps = CarouselProps &
  React.PropsWithChildren<{
    data: CarouselCardInfo[];
    onClick?: (id: any) => void;
  }>;

const CustomCarousel = ({ data, onClick }: customCarouselProps) => {
  const isMobile = useMobile();
  const { openModal } = useContext(ModalManagementStore);
  const navigate = useNavigate();

  const chunkedData = useMemo(() => {
    if (isMobile) {
      return chunk(data, 1);
    } else {
      return chunk(data, 3);
    }
  }, [data, isMobile]);

  return (
    <Container className={'custom-carousel p-0'}>
      <h4 className='mb-0'>Company Messages</h4>
      {isMobile ? <MobileCarousel chunkedData={chunkedData} >
          {chunkedData.map((items: any, i: number) => (
            <div key={i}>
              {items.map((item: any, idx: number) => (
                <Card
                  key={idx}
                  className={'item-col mx-1 p-5 pb-7 rounded-1 col-12 col-lg-4'}
                  style={{ background: 'white', width: '69vw' }}
                  onClick={() => {
                    if (item.modal) {
                      openModal(item.link);
                    }
                    else if (item.target === '_blank') {
                      window.open(item.link);
                    } else {
                      navigate(item.link);
                    }
                  }}
                >
                  <section style={{ background: 'white' }}>
                    <div className={'carousel-img-container'}>
                      <img
                        className={'radio-card-img'}
                        src={`${process.env.PUBLIC_URL}/${item.img}`}
                        alt={item.img}
                        style={{ width: '100%' }}
                      />
                    </div>
                    <div className='mt-4 lh-xs fw-light'>
                      <h6 className='mb-0 text-sm-16-lg-20'>{item.title}</h6>
                    </div>
                    <div className='lh-xxs fw-light text-sub1 text-light-grey-normal'>
                      <span>{item.subtitle}</span>
                    </div>
                  </section>
                </Card>
              ))}
            </div>

          ))}
      </MobileCarousel>:
        <Carousel className='mt-11'>
          {chunkedData.map((items: any, i: number) => (
            <Carousel.Item key={i}>
              <Row
                className={'m-0 justify-content-center align-items-center'}
                style={{ height: 364 }}
              >
                {items.map((item: any, idx: number) => (
                  <Col
                    key={idx}
                    className={'item-col mx-1 p-5 pb-7 rounded-1 col-12 col-lg-4'}
                    onClick={() => {
                      if (item.modal) {
                        openModal(item.link);
                      }
                      else if (item.target === '_blank') {
                        window.open(item.link);
                      } else {
                        navigate(item.link);
                      }
                    }}
                  >
                    <div className={'carousel-img-container'}>
                      <img
                        className={'radio-card-img'}
                        src={`${process.env.PUBLIC_URL}/${item.img}`}
                        alt={item.img}
                      />
                    </div>
                    <div className='mt-4 lh-xs fw-light'>
                      <h6 className='mb-0 text-sm-16-lg-20'>{item.title}</h6>
                    </div>
                    <div className='lh-xxs fw-light text-sub1 text-light-grey-normal'>
                      <span>{item.subtitle}</span>
                    </div>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>

      }
    </Container>
  );
};

export default CustomCarousel;
